import React from "react";
import why from "../../assets/8gkli4a_1521433 1.png";
import why1 from "../../assets/purepng.com-red-toyota-ft1-sports-carcarvehicletransporttoyotasports-car-961524645072laitz.png";
import why2 from "../../assets/Nero-Nemesis-Matt-Q0B9-777-640-en_US 1.png";
import why3 from "../../assets/Feature Image.png";

const WhyUs = () => {
  return (
    <>
      <div
        className="text-center leading-normal gap-6 flex flex-col items-center sm:mt-6 self-stretch sm:mb-14"
        style={{ fontFamily: "Barlow Condensed" }}
      >
        <h4
          className="font-normal text-3xl md:text-4xl lg:text-5xl text-black leading-normal w-11/12 md:w-4/5"
          style={{ fontFamily: "Ballega" }}
        >
          Why Us?
        </h4>
        <p className="text-black text-base md:text-xl leading-normal font-normal w-11/12 md:w-5/6">
          Step into a world of luxury and exclusivity with our collection of
          exotic cars. Whether you're buying or selling, we provide unmatched
          services tailored to meet your needs. With verified listings, expert
          assistance, and seamless transactions, we ensure a premium experience
          every step of the way. Trust us to connect you with the car of your
          dreams or the perfect buyer for your prized possession.
        </p>

        <section className="grid grid-cols-1 md:grid-cols-2 sm:my-9 justify-items-center px-4 sm:px-8 md:px-16 gap-5">
          {[
            {
              title: "Verified Exotic Listings",
              description:
                "Discover a curated range of rare and luxurious cars, thoroughly inspected and verified for quality.",
              imgSrc: why,
              imgAlt: "car",
            },
            {
              title: "Hassle-Free Transactions",
              description:
                "Enjoy smooth buying and selling experiences with secure processes and expert guidance every step of the way.",
              imgSrc: why1,
              imgAlt: "car1",
            },
            {
              title: "Flexible Finance Options",
              description:
                "Own your dream car with customized financing plans, low interest rates, and flexible repayment terms.",
              imgSrc: why2,
              imgAlt: "car2",
            },
            {
              title: "Personalized Assistance",
              description:
                "Our experts are here to help you find the perfect car or connect with the right buyer, tailored to your needs.",
              imgSrc: why3,
              imgAlt: "car3",
            },
          ].map(({ title, description, imgSrc, imgAlt }, index) => (
            <div
              key={index}
              className="px-6 sm:px-10 xl:px-20 py-10 sm:py-12 md:py-16 shadow-[-8px_-8px_20px_0px_rgba(0,_0,_0,_0.25)_inset,8px_8px_20px_0px_rgba(0,_0,_0,_0.25)_inset] rounded-xl"
            >
              <h4
                className="text-2xl md:text-3xl font-normal mb-4"
                style={{ fontFamily: "Ballega" }}
              >
                {title}
              </h4>
              <p className="text-sm md:text-base text-black font-normal leading-relaxed mb-6">
                {description}
              </p>
              <img
                src={imgSrc}
                alt={imgAlt}
                className="mt-4 md:mt-6 lg:mt-9"
              />
            </div>
          ))}
        </section>
      </div>
    </>
  );
};

export default WhyUs;
